import { Box, Typography } from "@mui/material";

export const PageNotFound = () => {
  return (
    <Box
      style={{
        height: "100%",
        width: "100%",
        overflow: "hidden",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography
        sx={{
          fontSize: { xs: "4.103vw", sm: "1.918vw", md: "1.12vw" },
          fontWeight: 600,
        }}
      >
        Page Not Found
      </Typography>
    </Box>
  );
};